import { SET_CURRENT_COURSE, SET_COURSE_PERCENT } from '../types';
import { getCourseSections } from './courseSections';

export const setCurrentCourse = (course) => dispatch => {
  dispatch({ type: SET_CURRENT_COURSE, course });
  dispatch(getCourseSections(course.id));
}

export const setCourseStats = (passedPercent) => (dispatch, getState) => {
  const course = getState().course;
  if (course && course.passedPercent !== passedPercent) {
    dispatch({ type: SET_COURSE_PERCENT, passedPercent });
  }
}